// extracted by mini-css-extract-plugin
module.exports = {"CardDetail":"CardDetail_CardDetail__2Ix5K"};